import { Capacitor } from "@capacitor/core";
import Vue from "vue";

// Capacitor's bridge detection can briefly report `web` while the WebView is
// starting. The mobile build marker makes the bundled APK deterministic while
// keeping the normal production website in browser mode.
const isNativeMobileBuild = process.env.VUE_APP_NATIVE_MOBILE === "true";

export const isNativeMobileApp = isNativeMobileBuild || (window.self === window.top && Capacitor.isNativePlatform());
export const useLiveMobilePortal = isNativeMobileBuild && process.env.VUE_APP_MOBILE_LIVE_PORTAL === "true";
export const embeddedMobileApp = Vue.observable({ active: false });
let embeddedNonce = "";

export function listenForEmbeddedAppContext(router) {
  if (window.self === window.top) return;
  const parentOrigin = "https://mobile.repairnestpos.com";
  window.addEventListener("message", (event) => {
    if (event.source !== window.parent || event.origin !== parentOrigin) return;
    const message = event.data || {};
    if (message.type === "repairnest:hello" && typeof message.nonce === "string" && message.nonce.length >= 16) {
      embeddedNonce = message.nonce;
      embeddedMobileApp.active = true;
      document.documentElement.classList.add("embedded-mobile-app");
      window.parent.postMessage({ type: "repairnest:ready", nonce: message.nonce, path: router.currentRoute.fullPath }, parentOrigin);
    } else if (embeddedMobileApp.active && message.nonce === embeddedNonce && message.type === "repairnest:navigate" && typeof message.path === "string" && message.path.startsWith("/") && !message.path.startsWith("//")) {
      router.push(message.path).catch(() => {});
    } else if (embeddedMobileApp.active && message.nonce === embeddedNonce && message.type === "repairnest:logout") {
      localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}token`);
      localStorage.removeItem(`${process.env.VUE_APP_STORAGE_PREFIX}organizationId`);
      window.parent.postMessage({ type: "repairnest:logged-out", nonce: message.nonce }, parentOrigin);
    }
  });
  router.afterEach((to) => {
    if (embeddedMobileApp.active) window.parent.postMessage({ type: "repairnest:navigated", nonce: embeddedNonce, path: to.fullPath }, parentOrigin);
  });
}

export function setMobileAppContext() {
  if (isNativeMobileApp) document.documentElement.classList.add("native-mobile-app");
}
